<script>
import {
    showModal
} from '@app/store/modalStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    editorState
} from "@app/store/editorStore.svelte.js";
import insertEv from '@cclib/functions/eventGroups/insertEvent.js';
import insertColorByLine from '@cclib/functions/quill/insertColorByLine.js';
import * as m from '@app/paraglide/messages.js';

/** @type {{currentState: boolean, toggleMenu: (menu: string) => void}} */
let { currentState, toggleMenu } = $props();

function handleToggleMenu() {
    toggleMenu('insert');
}

function insertEvent(above = false) {
    let eventOptions;
    let eventIndex = eventGroupState[projectState.selected].selected.length > 0 ? eventGroupState[projectState.selected].selected[0] : null;
    eventIndex = above ? eventIndex : eventIndex !== null ? eventIndex + 1 : null;
    
    if (eventGroupState[projectState.selected].events.length > 0){
        try {
            let eventTemplate = eventGroupState[projectState.selected].selected.length > 0 ? eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].selected[0]] : eventGroupState[projectState.selected].events[eventGroupState[projectState.selected].events.length-1];

            eventOptions = {
                alignment : eventTemplate.alignment, 
                xPos : eventTemplate.xPos,
                yPos : eventTemplate.yPos,
                writingMode : eventTemplate.writingMode,
                voice : eventTemplate.voice,
                speakingStyle : eventTemplate.speakingStyle,
                style : eventTemplate.style,
                rate : eventTemplate.rate,
                start: editorState.insertStartOnInsert ? player.currentTime : false,
                end: editorState.insertStartOnInsert ? player.currentTime + eventGroupState[projectState.selected].minDuration : false,
            }     
        } catch(err){
            console.log(err);
        }
    }

    eventGroupState[projectState.selected] = insertEv(eventGroupState[projectState.selected], eventOptions, eventIndex);
    eventGroupState[projectState.selected].selected = eventIndex !== null ? [eventIndex] : [eventGroupState[projectState.selected].events.length - 1];

    insertHistoryAction({
        name: "insert event", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
}

function insertBlock() {
    if (window.quillEditor === undefined){
        return;
    }
    
    let range = window?.quillEditor?.getSelection();
    if (range) {
        window.quillEditor.insertText(range.index, "█", "api");
        insertHistoryAction({
            name: "insert block", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    }
}

function insertEllipsis() {
    if (!window.quillEditor){
        return;
    }

    try {
        let range = window.quillEditor?.getSelection();
        if (range) {
            window.quillEditor.insertText(range.index, "…", "api");
            insertHistoryAction({
                name: "insert ellipsis", //action name
                eventGroup: projectState.selected,
                snapshots: [{
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState)
                }]
            });
        }
    } catch (err){
        console.log(err.message);
    }    
}

//For each selected event, if a speaker is assigned to the event, update the event text to include span tags with the speaker color set to match.
function insertSpeakerColor(){
    if (eventGroupState.length === 0 || projectState.selected === null || eventGroupState[projectState.selected].selected.length === 0){
        return;
    }

    eventGroupState[projectState.selected].selected.forEach((evIndex, count) => {
        let ev = eventGroupState[projectState.selected].events[evIndex];
        if (ev.speakers.length === 0){
            return;
        }

        if (ev.speakers.length === 1){
            //If there is only one speaker assigned to the event then we update the color of all lines to the same color as the speaker.
            let speaker = ev.speakers[0];            
            ev.text = insertColorByLine(ev.text, speaker.colour)
        } else {
            console.log("Multiple speakers assigned to event, coloring each line based on speaker index.");
            //If there is more than one speaker assigned to the event, then we need to color each line based on the speaker at that index. E.g. line 1 gets the color of speaker 1, line 2 gets the color of speaker 2, etc.
            ev.text.split("</p>").forEach((line, lineIndex) =>{
                let speaker = ev.speakers[lineIndex] || ev.speakers[0];
                ev.text = insertColorByLine(ev.text, speaker.colour, lineIndex)
            });
        }

        if (count === 0 && window.quillEditor){
            let delta = window.quillEditor.clipboard.convert({ html: ev.text });
            window.quillEditor.setContents(delta, "silent");
            window.quillEditor.formatLine(0,9999, 'align', ev.alignment === 'left' ? '' : ev.alignment, "silent");
        }
    });

    insertHistoryAction({
        name: "insert speaker color", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
}

</script>

<li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
    <a onclick={handleToggleMenu} 
       class="dropdown-toggle nav-link" 
       href="#!/" 
       id="insertMenuButton"
       aria-haspopup="true"
       aria-expanded={currentState}
       role="button"
       aria-label={m.insert_menu()}>{m.insert()}</a>
    <div class="dropdown-menu {currentState ? 'show' : ''}" 
         role="menu" 
         aria-labelledby="insertMenuButton">
        <a class="dropdown-item" href="#!/" onclick={() => insertEvent(true)} id="insertEventBefore" aria-label={m.insert_event_before()} role="menuitem"><i class="bi bi-arrow-up-circle" aria-hidden="true"></i> {m.event_before()}</a>
        <a class="dropdown-item" href="#!/" onclick={() => insertEvent(false)} id="insertEventAfter" aria-label={m.insert_event_after()} role="menuitem"><i class="bi bi-arrow-down-circle" aria-hidden="true"></i> {m.event_after()}</a>
        <hr class="dropdown-divider">
        <a class="dropdown-item" href="#!/" onclick={() => {insertBlock()}} id="insertBlock" aria-label={m.insert_full_block()} role="menuitem">{m.full_block()}</a>
        <a class="dropdown-item" href="#!/" onclick={() => {insertEllipsis()}} id="insertEllipsis" aria-label={m.insert_ellipsis()} role="menuitem">{m.ellipsis_char()}</a>
        <a class="dropdown-item" href="#!/" onclick={() => showModal("musicNotes")} id="insertMusicNotes" aria-label={m.insert_music_notes()} role="menuitem">{m.music_notes()}</a>
        <a class="dropdown-item" href="#!/" onclick={() => showModal("insertSpeaker")} id="insertSpeaker" aria-label={m.insert_speaker_name()} role="menuitem">{m.speaker_name()}</a>
        <!-- Insert Speaker Color -->
        <a class="dropdown-item" href="#!/" onclick={() => insertSpeakerColor()} id="insertSpeakerColor" aria-label={m.insert_speaker_color()} role="menuitem">{m.speaker_color()}</a>
        <hr class="dropdown-divider">
        <a class="dropdown-item" href="#!/" onclick={() => showModal("blankFrames")} id="insertBlankFrames" aria-label={m.insert_blank_frames()} role="menuitem">{m.blank_frames()}</a>
    </div>
</li>
